import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "TrainingRegistrationAdd" })
export default class TrainingRegistrationAdd extends Vue {
    public localizer: any = Localizer;
    public courseData: any = null;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public isUnsubscribe: boolean = false;
    public validationErrors: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly trainingCourseIdMaster: string;
    @Prop() readonly returnUrl: string;
    @Prop() readonly trainingCourseTitle: string;

    public async created() {
        await this.getData();
    }

    public async getData() {
        this.courseData = (await Axios.post(this.routes.MyBremboPartsTraining_GetTrainingRegistrationData, { trainingCourseIdMaster: this.trainingCourseIdMaster })).data;
    }

    public async submitRegistration() {
        this.isLoading = true;

        try {
            this.isSuccess = false;

            await Axios.post(this.routes.MyBremboPartsTraining_SetTrainingRegistrationData, { trainingCourseIdMaster: this.trainingCourseIdMaster });

            this.isSuccess = true;

            GTagHelper.sendEvent("form_submit", "course_subscribe");

            window.location.href = window.location.href;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public async submitUnsubscribe() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            this.isSuccess = false;

            const result = (await Axios.post(this.routes.MyBremboPartsTraining_UpdateTrainingRegistrationData, { trainingCourseIdMaster: this.trainingCourseIdMaster })).data;

            this.isSuccess = true;
            GTagHelper.sendEvent("form_submit", "course_unsubscribe");

            window.location.href = result.redirectUrl;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
        if (this.isSuccess) {
            this.isUnsubscribe = true;
        }
    }

    public openAccountEdit() {
        let redirectUrl = this.routes.Account_Profile_Edit;
        if (this.returnUrl) {
            redirectUrl += "?returnurl=" + this.returnUrl;
        }

        window.location.href = redirectUrl;
    }
};